const { NODE_ENV } = process.env

export const PRODUCTION = NODE_ENV === 'production'
export const DEVELOPMENT = !PRODUCTION

export const FEATHERS_HOST = NODE_ENV === 'production'
  ? 'https://feathers.looknorthservices.com'
  : 'http://localhost:3030'

export const TUSD_HOST = 'https://upload.looknorthservices.com/files/'



// WEBPACK FOOTER //
// ./src/config.js